module.exports = __webpack_public_path__ + "static/media/stoneleigh-park-aerial-cropped.e66aaf70.png";